module.exports = __webpack_public_path__ + "static/cover2-1bb5e8be588a638dc1fcebee49bb5560.jpeg";